import { Routes } from '@angular/router';
import { ComponenteLogin } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { GuardiaAutenticacion } from './auth/auth.guard';
import { IncongruenciasComponent } from './incongruencias/incongruencias.component';
import { PlanComponent } from './plan/plan.component';
import { UsuarioComponent } from './usuario/usuario.component';
import { TitularYAdherentesComponent } from './titular-y-adherentes/titular-y-adherentes.component';
import { PersonaComponent } from './persona/persona.component';
import { SubirArchivoComponent } from './subir-archivo/subir-archivo.component';
import { PersonaComparacionComponent } from './persona-comparacion/persona-comparacion.component';
import { ServicioAutenticacion } from './auth/auth.service';
import { CodigoGestosComponent } from './codigo-gestos/codigo-gestos.component';
import { UsuarioEditarComponent } from './usuario-editar/usuario-editar.component';
import { VendedorComponent } from './vendedor/vendedor.component';
import { EmpresaComponent } from './empresa/empresa.component';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: ComponenteLogin },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [GuardiaAutenticacion],
    data: { roles: ServicioAutenticacion.MENU_PERMISSIONS['inicio'] },
  },
  {
    path: 'incongruencias',
    component: IncongruenciasComponent,
    canActivate: [GuardiaAutenticacion],
    data: { roles: ServicioAutenticacion.MENU_PERMISSIONS['reportes'] },
  },
  {
    path: 'planes',
    component: PlanComponent,
    canActivate: [GuardiaAutenticacion],
    data: { roles: ServicioAutenticacion.MENU_PERMISSIONS['planes'] },
  },
  {
    path: 'personas',
    component: PersonaComponent,
    canActivate: [GuardiaAutenticacion],
    data: { roles: ServicioAutenticacion.MENU_PERMISSIONS['personas'] },
  },
  {
    path: 'usuarios',
    component: UsuarioComponent,
    canActivate: [GuardiaAutenticacion],
    data: { roles: ServicioAutenticacion.MENU_PERMISSIONS['usuarios'] },
  },
  {
    path: 'titular-y-adherentes',
    component: TitularYAdherentesComponent,
    canActivate: [GuardiaAutenticacion],
    data: { roles: ServicioAutenticacion.MENU_PERMISSIONS['personas'] },
  },
  {
    path: 'subir-archivo',
    component: SubirArchivoComponent,
    canActivate: [GuardiaAutenticacion],
    data: { roles: ServicioAutenticacion.MENU_PERMISSIONS['archivos'] },
  },
  {
    path: 'persona-comparacion',
    component: PersonaComparacionComponent,
    canActivate: [GuardiaAutenticacion],
    data: { roles: ServicioAutenticacion.MENU_PERMISSIONS['archivos'] },
  },
  {
    path: 'codigo-gestos',
    component: CodigoGestosComponent,
    canActivate: [GuardiaAutenticacion],
    data: { roles: ServicioAutenticacion.MENU_PERMISSIONS['archivos'] },
  },
  {
    path: 'usuario-editar',
    component: UsuarioEditarComponent,
    canActivate: [GuardiaAutenticacion],
  },
  {
    path: 'vendedores',
    component: VendedorComponent,
    canActivate: [GuardiaAutenticacion],
    data: { roles: ServicioAutenticacion.MENU_PERMISSIONS['personas'] },
  },
  {
    path: 'empresas',
    component: EmpresaComponent,
    canActivate: [GuardiaAutenticacion],
    data: { roles: ServicioAutenticacion.MENU_PERMISSIONS['personas'] },
  },
  { path: '**', redirectTo: '/login' },
];
